export const GET_SKU_MANAGEMENT_REQUEST = "GET_SKU_MANAGEMENT_REQUEST";
export const GET_SKU_MANAGEMENT_SUCCESS = "GET_SKU_MANAGEMENT_SUCCESS";
export const GET_SKU_MANAGEMENT_FAILURE = "GET_SKU_MANAGEMENT_FAILURE";

export const GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_REQUEST =
  "GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_REQUEST";
export const GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS =
  "GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS";
export const GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_FAILURE =
  "GET_SKU_MANAGEMENT_WITHOUT_PAGINATION_FAILURE";

export const EDIT_SKU_REQUEST = "EDIT_SKU_REQUEST";
export const EDIT_SKU_SUCCESS = "EDIT_SKU_SUCCESS";
export const EDIT_SKU_FAILURE = "EDIT_SKU_FAILURE";

export const GET_SHIPMENT_REQUEST = "GET_SHIPMENT_REQUEST";
export const GET_SHIPMENT_SUCCESS = "GET_SHIPMENT_SUCCESS";
export const GET_SHIPMENT_FAILURE = "GET_SHIPMENT_FAILURE";

export const PRINT_SKU_REQUEST = "PRINT_SKU_REQUEST";
export const PRINT_SKU_SUCCESS = "PRINT_SKU_SUCCESS";
export const PRINT_SKU_FAILURE = "PRINT_SKU_FAILURE";

export const RELEASE_SHIPMENT_REQUEST = "RELEASE_SHIPMENT_REQUEST";
export const RELEASE_SHIPMENT_SUCCESS = "RELEASE_SHIPMENT_SUCCESS";
export const RELEASE_SHIPMENT_FAILURE = "RELEASE_SHIPMENT_FAILURE";

export const CREATE_SKU_REQUEST = "CREATE_SKU_REQUEST";
export const CREATE_SKU_SUCCESS = "CREATE_SKU_SUCCESS";
export const CREATE_SKU_FAILURE = "CREATE_SKU_FAILURE";

export const GET_SKU_BY_ITEMID_REQUEST = "GET_SKU_BY_ITEMID_REQUEST";
export const GET_SKU_BY_ITEMID_SUCCESS = "GET_SKU_BY_ITEMID_SUCCESS";
export const GET_SKU_BY_ITEMID_FAILURE = "GET_SKU_BY_ITEMID_FAILURE";

export const UPLOADCSV_FOR_SALES_ORDER_REQUEST =
  "UPLOADCSV_FOR_SALES_ORDER_REQUEST";
export const UPLOADCSV_FOR_SALES_ORDER_SUCCESS =
  "UPLOADCSV_FOR_SALES_ORDER_SUCCESS";
export const UPLOADCSV_FOR_SALES_ORDER_FAILURE =
  "UPLOADCSV_FOR_SALES_ORDER_FAILURE";

export const GET_SKU_BY_SKUTYPE_REQUEST = "GET_SKU_BY_SKUTYPE_REQUEST";
export const GET_SKU_BY_SKUTYPE_SUCCESS = "GET_SKU_BY_SKUTYPE_SUCCESS";
export const GET_SKU_BY_SKUTYPE_FAILURE = "GET_SKU_BY_SKUTYPE_FAILURE";

export const GET_MAPPED_SKU_REQUEST = "GET_MAPPED_SKU_REQUEST";
export const GET_MAPPED_SKU_SUCCESS = "GET_MAPPED_SKU_SUCCESS";
export const GET_MAPPED_SKU_FAILURE = "GET_MAPPED_SKU_FAILURE";

export const PRINT_SECONDARY_SKU_REQUEST = "PRINT_SECONDARY_SKU_REQUEST";
export const PRINT_SECONDARY_SKU_SUCCESS = "PRINT_SECONDARY_SKU_SUCCESS";
export const PRINT_SECONDARY_SKU_FAILURE = "PRINT_SECONDARY_SKU_FAILURE";
